import React, { Component } from "react";
import Header from "../Header";
import Menu from "../Menu";
import { Link } from "react-router-dom";
import { SURGEON } from "../../services/Surgeon";
import { QUESTION } from "../../services/Questions";
import Check from './complain/Check';
import { CONFIG, URLS, checkAuth, getLoggedInData} from "../../helpers/Common";
import { Modal , Container} from "react-bootstrap";
import "../../assets/css/question.css";
import "../../assets/css/new_style.css";
import "../../assets/css/custom.css";
import AddQuestionsForm from "./components/AddQuestionsForm";

class QuestionBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: '',
      narrative_id: 0,
      complainTypes: new Array(),
      seletedComplain:"",
      searchKeyword:"",
      questionData: new Array(),
      questionOptionData: new Array(),
      patientId:'',
      questionTitle:'',
      questionId:'',
      optionId:'',
      displayInputText:'',
      selectOptionData: new Array(),
      surgeon_id:'',
      response:'',
      show: false,
    };
    this.selectComplainType   = this.selectComplainType.bind(this);
    this.addKeyword           = this.addKeyword.bind(this);
    this.searchQuestion       = this.searchQuestion.bind(this);
    //this.addCurrentQuestionId = this.addCurrentQuestionId.bind(this);
    this.saveQuestion        = this.saveQuestion.bind(this);
    
    this.getLoggedInData    = getLoggedInData.bind(this)// Import from common
    this.checkAuth          = checkAuth.bind(this)// Import from common
  }

  componentWillMount() {
    checkAuth();
    let userData = getLoggedInData();
    this.setState({
      userData: userData,
      surgeon_id: userData.user_id
    });
    try {
      this.setState({
        narrativeSummary: this.props.location.state.patientData.narrative_summary,
      });
    } catch (e) {
      this.props.history.push('/surgeon/patients/');
    }
  }

  componentDidMount() {
    let id  = this.props.location.pathname.split('/');
    id      = id[(id.length)-1];
    this.setState({
        patientId:id
    });
    SURGEON.getPatientComplains(id).then(res => {
      if(res.data.header.error==0)
      {   
        let complainTypes       = res.data.body.details;
        let ref = this;
        this.setState({
          complainTypes: complainTypes,
          isLoading: false,
        });
      }
      
    }).catch(err => {
        return err;
    });
    // QUESTION.getChiefComplainTypes().then(res => {
    //   if(res.data.header.error==0)
    //   {   
          
    //       let complainTypes       = res.data.body.details;
    //       this.setState({
    //           complainTypes: complainTypes,
    //           isLoading: false,
    //       });
    //   }
    // }).catch(err => {
    //   return err;
    // });

  }
  selectComplainType = (e)=>
  { 
    this.setState({
      seletedComplain : e.target.value
    })
  }
  handleClose = () => {
    this.props.history.push({
      pathname: "/surgeon/patient/narrative/"+this.state.patientId,
      state: { patientData:this.props.location.state.patientData},
    });
  }

  handleShow = () => {
    this.setState({ show: true });
  }
  addKeyword = (e)=>
  { 
    this.setState({
      searchKeyword : e.target.value
    })
  }
  searchQuestion = (e)=>
  { 
    let selectCompalin  = this.state.seletedComplain;
    let keyword         = this.state.searchKeyword;
    let searchProcess   = true;
    
    if(!selectCompalin)
    {
      alert('Please select chief complain');
      searchProcess = false;
    }
    if(!keyword)
    {
      alert('Search keyword is required');
      searchProcess = false;
    }
    if(searchProcess)
    { 

      this.setState({
        isLoading: true,
        questionData: new Array(),
        questionOptionData: new Array(),
        questionTitle: ''
      });

      SURGEON.searchQuestion(selectCompalin,keyword,this.state.patientId).then(res => {
        if(res.data.header.error==0)
        {   
            
            let questionData       = res.data.body.details;
            this.setState({
              questionData: questionData,
              isLoading: false,
            });
          
        }
        if(res.data.header.error==1)
        {
          alert('No Question Available');
        }
      }).catch(err => {
        return err;
      });
    }
  }
 
  // addCurrentQuestionId = (id) =>
  // { 
  //   this.setState({
  //     questionId:id
  //   })
  //   let questionOption = new Array();
  //   let questionTitle = "";
  //   Object.values(this.state.questionData).forEach(function(row,key) 
  //   { 
  //     if(row.id==id)
  //     { 
  //       questionOption = row.options;
  //       questionTitle   = row.name;
        
  //     }
  //   })
  //   this.setState({
  //     questionOptionData:questionOption,
  //     questionTitle:questionTitle
  //   })
  // }

  // addCurrentOptionId= (id) =>
  // {
  //   this.setState({
  //     optionId:id
  //   })

  //   let selectOptionData = new Array();
  //   Object.values(this.state.questionOptionData).forEach(function(row,key) 
  //   { 
  //     if(row.id==id)
  //     { 
  //       selectOptionData = row;
        
  //     }
  //   })
  //   this.setState({
  //     selectOptionData:selectOptionData,
  //   })
  // }

  addInputTextInOptionAnswers=(e)=>
  {
    this.setState({
      displayInputText:e.target.value
    })
  }

  saveQuestion=(e)=>
  {
    let saveData = new Array();
    let questionId  = this.state.questionId;
    let response    = this.state.response;
    
    if(questionId && response)
    {
    
      SURGEON.saveSearchQuestionOption(this.state.questionId,this.state.response,this.state.patientId,this.state.seletedComplain,this.state.surgeon_id).then(res => {
        this.handleShow();
        
      }).catch(err => {
          alert("There was an error ");
      });
    }
    else
    {
      alert('question and response required');
    }
    
    
  }
  saveInputFields = (e)=>
  { 
    
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  addQuestionResponse=(e)=>
  { 
    this.props.history.push({
      pathname: "add/"+this.state.patientId,
      state: { patientData:this.props.location.state.patientData},
    });
   
  }
  redirect=(e)=>
  {
    this.props.history.push({
      pathname: "/surgeon/patient/narrative/"+this.state.patientId,
      state: { patientData:this.props.location.state.patientData},
    });
  }
  render() {
    return (
      <React.Fragment>
        <Header
          title="Patient Symptoms Narrative"
          titleImage="ic-conversation.png"
        />
        <Menu />
        <section className="sec--question sec--custom-question sec--question-bank">
          <div className="banner">
            <div className="container">
            <img src="./../../assets/img/bg/banner.jpg" alt="" />
              <div className="bg-content">
                <div className="bg-content-detail">
                  <div className="bg-tabs-btn">
                    <a href="#" className="btn-ques-bank active">
                      Add Questions from Question Bank
                    </a>
                    <Link to="#" onClick={this.addQuestionResponse} className="btn-add-ques">
                      Add New Questions
                    </Link>
                    
                  </div>
                  <div className="bg-detail-fields">
                    <div className="bg-select">
                      <label htmlFor="">
                        Chief Complain <span>*</span>
                      </label>
                      <select onChange={this.selectComplainType}>
                      <option value="">Please Select Complain Type</option>

                        {Object.values(this.state.complainTypes).map((row, key) => (
                          <option value={`${row.id}`}>{row.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="bg-search">
                      <div className="form-group">
                        <label htmlFor="">Search Keywords</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Light Sensitivity"
                          onChange={this.addKeyword}
                        />
                        <a href="javascript: void(0);" onClick={this.searchQuestion} className="search-icon">
                          <img src={require("../../assets/img/icons/ic-search.png")} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <AddQuestionsForm 
          saveInputFields={this.saveInputFields}
          saveQuestion={this.saveQuestion}
          title={this.state.title}
          response={this.state.response}
          resetField={this.resetField}
          questionBank={true}
          questionData={this.state.questionData}
          />          
            
        </section>

        <div className="sec-btn">
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">Narrative has been added</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
            <div className="sec-btn patient--btn">
              <Link to="#" onClick={this.redirect} className="btn-img" onClick={this.handleClose}>
                <img
                  src={require("../../assets/img/icons/ic-complete-native.png")}
                  alt=""
                />
                <span>Go to Patient Narrative</span>
              </Link>
            </div>
            </Container>
          </Modal.Body>
        </Modal>
        <Link to="#" onClick={this.redirect} className="btn-img">
          <img src={require("../../assets/img/icons//ic-import-question.png")} />
          <span>
            Go to Patient
            <br />
            Narrative
          </span>
        </Link>
        <Link to="#" onClick={this.saveQuestion} className="btn-img">
          <img src={require("../../assets/img/icons/ic-add-question.png")} />
          <span>
            Add Response
            
          </span>
        </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default QuestionBank;
